import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {UserResponse} from "../interface/userResponse";
import intlTelInput from "intl-tel-input";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {UserCardService} from "../service/user-card.service";
import {UserCardResponse} from "../interface/userCardResponse";
import {UserCardUtil} from "../utilityClass/userCardUtil";
import {CreateUserCard} from "../interface/createUserCard";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {UserContentComponent} from "../user-content/user-content.component";
import {UserCardContentRequest} from "../interface/userCardContentRequest";
import {ContentType} from "../interface/contentType";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContentService} from "../service/content.service";
import {ContentResponse} from "../interface/contentResponse";
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

import {maxLengthConstant} from "../constants/maxLength.constant";
import {Hashtag} from "../interface/hashtag";
import {HashtagService} from "../service/hashtag.service";
import {CoverImageCropperDialogComponent} from "../cover-image-cropper-dialog/cover-image-cropper-dialog.component";
import {
  ProfileImageCropperDialogComponent
} from "../profile-image-cropper-dialog/profile-image-cropper-dialog.component";
import {ToggleSelectElModel} from "../layouts/toggle-select/toggle-select-el.model";
import {ToggleElModel} from "../layouts/toggle/toggle-el.model";
import {BehaviorSubject, interval, map, Observable, Subscription} from "rxjs";
import {DeleteProfileCardComponent} from "../profile-card/delete-profile-card/delete-profile-card.component";
import {Action} from "../interface/action";
import {DELETE_CONTENT_TITLE, DELETE_DESCRIPTION} from "../constants/deleteProfileCards.constant";
import {EditContentDialogComponent} from "../edit-content-dialog/edit-content-dialog.component";
import {UserCardContent} from "../interface/userCardContent";
import {ADD_CONTENT_SUCCESS_ALERT_TEXT} from "../constants/global.constants";
import {SubscriptionService} from "../service/subscription.service";
import {SubscriptionResponse} from "../interface/subscriptionResponse";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {UserService} from "../service/user.service";
import {Router, RouterStateSnapshot} from "@angular/router";
import {UserCardSubscriptionUtil} from "../utilityClass/userCardSubscriptionUtil";
import {SaveChangesComponent} from "../profile-card/save-changes-popup/save-changes.component";
import {SharedConstants} from "../utilityClass/sharedConstants";
import {HASHTAGS_MAX_LENGTH} from "../constants/validation.constants";
import {TranslateService} from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-create-card',
  templateUrl: './create-card.component.html',
  styleUrls: ['./create-card.component.scss', "../shared/scss/userCardCommon.scss"]
})
export class CreateCardComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() cardCreated = new EventEmitter<UserCardResponse>();
  user: UserResponse | any

  selectedTab: 'About' | 'Content' = 'About';
  multiSelectLabel: string = '';
  hashtagListValueChangesSubscription: Subscription | undefined;

  userCardContentRequest: UserCardContentRequest [] = []
  contentResponse: ContentResponse | any
  contentWithDocId: bigint | any
  panelOpenState = true;
  form: FormGroup | any;
  iti: intlTelInput.Options | any;
  phone: ElementRef<HTMLInputElement> | any;
  tempProfileImage: File | null = null;
  tempCompanyLogo: File | null = null;
  tempCoverImage: File | null = null;
  documentFile: File | any
  length: number = 0
  contentIcon: string = '';
  characterCount: number = 0;
  fieldsLengthLimit: any;
  matchingLineHashtags: Array<Hashtag> = [];
  notFoundText: 'Search' | 'No result found' | '' = 'Search';
  currentPageIndexForSearch: number = 0;
  pageSize: number = 10;
  currentQueryForSearch = '';
  scrollStep: number = 1000;
  isRedirecting = false;
  nextUrl: string | null = null;
  isOpenPopup = true;

  showSeeMoreButton = false;
  isSingleLink: boolean = false;
  isContentViewGrid: boolean = false;
  activeIndividualSubscriptionPlan!: SubscriptionResponse;

  @ViewChild('ngSelectElement', {read: ElementRef}) ngSelectElement!: ElementRef;
  @ViewChild('imageInput') imageInput!: ElementRef;
  @ViewChild('coverImageInput') coverImageInput!: ElementRef;
  @ViewChild('companyLogo') companyLogo!: ElementRef;

  dialogRef: MatDialogRef<UserContentComponent> | undefined;
  dialogRefDeleteContent: MatDialogRef<DeleteProfileCardComponent> | undefined;

  public static contentAddEmitter: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private userCardService: UserCardService,
    private userCardUtil: UserCardUtil,
    private dialog: MatDialog,
    private contentService: ContentService,
    private snackBar: MatSnackBar,
    private hashtagService: HashtagService,
    private subscriptionService: SubscriptionService,
    private snackBarUtil: SnackBarUtil,
    private userService : UserService,
    private router: Router,
    private userCardSubscriptionUtil: UserCardSubscriptionUtil,
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.userService.currentUser.subscribe(response => {
      this.user = response
    })
    this.fieldsLengthLimit = this.userCardUtil.getFieldsLengthLimit()
    this.userCardUtil.characterCount$.subscribe(count => {
      this.characterCount = count;
    });
    if (this.user) {
      this.initializeForm()
    }
    this.fetchDefaultValues()

    CreateCardComponent.contentAddEmitter.subscribe((res: any) => {
      if (res && res.userCardContent) {
        this.afterClosedAddUserCardContent(res!);
      }
    });
    this.userCardContentRequest = [];
    this.loadIndividualSubscription()
  }

  ngAfterViewInit(): void {
    const phoneInput: HTMLInputElement | any = this.phone?.nativeElement;
    if (phoneInput) {
      this.iti = this.userCardUtil.initializeIntlTelInput(phoneInput, this.user.countryIso);
    }
  }

  ngOnDestroy(): void {
    this.hashtagListValueChangesSubscription?.unsubscribe();
  }

  canDeactivate(nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.form.dirty && this.isOpenPopup) {
      if (this.isRedirecting) {
        this.isRedirecting = false;
        return true;
      }

      this.nextUrl = nextState?.url || null;

      const dialogRef = this.dialog.open(SaveChangesComponent);

      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.createCard();
        } else {
          this.isRedirecting = true;
          this.router.navigateByUrl(this.nextUrl || '/cards');
        }
      });

      return dialogRef.afterClosed().pipe(map(result => result === true));
    }

    return true;
  }

  initializeForm(): void {
    this.form = new FormGroup({
        name: new FormControl(this.user?.name, [Validators.required, Validators.minLength(2), Validators.maxLength(50), this.userCardUtil.whitespaceValidator()]),
        surname: new FormControl(this.user?.surname, [Validators.required, Validators.minLength(2), Validators.maxLength(50), this.userCardUtil.whitespaceValidator()]),
        about: new FormControl('', [Validators.maxLength(this.fieldsLengthLimit.maxLengthBio), this.whitespaceValidator()]),
        specialization: new FormControl('', [Validators.maxLength(this.fieldsLengthLimit.maxLengthCommon), this.whitespaceValidator()]),
        company: new FormControl('', [Validators.maxLength(this.fieldsLengthLimit.maxLengthCommon), this.whitespaceValidator()]),
        location: new FormControl('', [Validators.maxLength(this.fieldsLengthLimit.maxLengthCommon), this.whitespaceValidator()]),
        hashtagList: new FormControl([], [Validators.maxLength(HASHTAGS_MAX_LENGTH)])
      },
      {updateOn: 'blur'});

    const hashtagList = this.form.get('hashtagList');
    this.multiSelectLabel = 'user_card.max_3_allowed';
    this.hashtagListValueChangesSubscription = hashtagList.valueChanges.subscribe(() => {
      this.multiSelectLabel = hashtagList.value.length == 0 ? 'user_card.max_3_allowed' : '';
    });
  }

  returnToPreviousPage() {
    this.router.navigate(['/cards'])
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  createCard(): void {
    const createCard: CreateUserCard = {
      name: this.form.value.name,
      surname: this.form.value.surname,
      about: this.form.value.about,
      specialization: this.form.value.specialization,
      company: this.form.value.company,
      location: this.form.value.location,
      userId: this.user.id,
      tags: this.mapHashtagList(),
      userCardContentRequest: this.getUserCardContentWithoutFiles(),
      contentViewGrid: this.isContentViewGrid,
      singleLink: this.isSingleLink,
    };

    this.form.markAllAsTouched();
    const formData = new FormData();
    if (this.tempProfileImage) {
      formData.append('profilePicture', this.tempProfileImage);
    }
    if (this.tempCoverImage) {
      formData.append('coverPicture', this.tempCoverImage);
    }
    if (this.tempCompanyLogo) {
      formData.append('companyLogo', this.tempCompanyLogo);
    }

    if (this.form.valid) {
      this.userCardService.createCard(createCard).subscribe({
        next: (cardResponse: UserCardResponse) => {
          this.matchingLineHashtags = [];
          this.initializeForm();
          this.processUploadDocument(cardResponse);
          if (this.tempProfileImage || this.tempCoverImage || this.companyLogo) {
            this.userCardService.uploadImage(formData, cardResponse.id).subscribe({
              next: (response: { [key: string]: string }) => {
                cardResponse.profilePic = response["profilePicture"];
                cardResponse.coverImage = response["coverPicture"];
                cardResponse.companyLogo = response["companyLogo"];
                this.cardCreated.emit(cardResponse);
                this.isOpenPopup = false;
                this.router.navigate(['/cards']);
              }
            });
          } else {
            this.cardCreated.emit(cardResponse);
          }
        }
      });
    }
  }

  getContentIcon(image: string) {
    return this.contentService.getImage(image)
  }

  getNameSurnameErrorMessage() {
    return this.userCardUtil.getNameSurnameLengthErrorMessage()
  }

  getCommonFieldsErrorMessage(maxLength: number) {
    return this.userCardUtil.getCommonFieldsLengthErrorMessage(maxLength)
  }

  processUploadDocument(cardResponse: UserCardResponse) {
    const userCardContentWithDoc: UserCardContent | undefined = cardResponse.userCardContent.find(userCardContent => userCardContent.content.contentType === ContentType.DOCUMENT);

    if (!userCardContentWithDoc) return;

    if (userCardContentWithDoc.placeholder.endsWith('.pdf') && this.documentFile) {
      const formDataDoc = new FormData();
      formDataDoc.append('documentFile', this.documentFile)
      this.contentWithDocId = userCardContentWithDoc.id;
      this.uploadDocument(formDataDoc, this.contentWithDocId)
    }
  }

  whitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value;
      if (value !== null && value.trim().length === 0 && value !== '') {
        return {whitespace: true};
      }
      return null;
    };
  }

  shouldBeDisabled(userCardContent: UserCardContentRequest): boolean {
    const subscriptionInfo = this.activeIndividualSubscriptionPlan?.subscriptionInfoResponse;
    return this.userCardSubscriptionUtil.checkIsContentShouldBeDisabled(userCardContent, subscriptionInfo, this.userCardContentRequest);
  }

  uploadDocument(formDataDoc: FormData, contentWithDocId: bigint) {
    this.userCardService.uploadDocument(formDataDoc, contentWithDocId).subscribe({
        next: () => {

        },
        error: error => {
          this.handleErrorResponse(error)
        }
      },
    );
  }

  openEditContentModal(userCardContent: UserCardContentRequest) {
    this.dialog.open(EditContentDialogComponent, {data: userCardContent}).afterClosed()
      .subscribe({
        next: (data: any) => {
          if (data.updatedContent) {
            userCardContent = data.updatedContent;
          }
          if (data.isUpdated) {
            this.documentFile = data.document
          }
        }
      });
  }

  openAddContentModal() {
    this.length = this.userCardContentRequest.filter(item => item.type == ContentType.DOCUMENT).length
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      userCardContentDocumentCount: this.length,
    }
    this.dialogRef = this.dialog.open(UserContentComponent, dialogConfig);
  }

  onDisabledOptionClick() {
    if (this.form.get('hashtagList').value.length > 3) {
      this.showSnackbar(MockupDataModel.error("Only 3 hashtags allowed."), SnackBarUtil.CLASSES.error);
    }
  }

  deleteProfileImage(): void {
    this.tempProfileImage = null;
  }

  deleteCompanyLogo(): void {
    this.tempCompanyLogo = null;
  }

  private afterClosedAddUserCardContent(data: { userCardContent: UserCardContentRequest, documentFile: any }) {
    const subscriptionInfo = this.activeIndividualSubscriptionPlan?.subscriptionInfoResponse;

    this.userCardSubscriptionUtil.checkSubscriptionPermittedContentLimits(data.userCardContent, subscriptionInfo, this.userCardContentRequest)
    this.documentFile = data.documentFile
    this.userCardContentRequest.push(data.userCardContent);
    this.getContentIcon(data.userCardContent.contentIcon);

    if (this.userCardContentRequest.includes(data.userCardContent) && data.userCardContent.active) {
      this.showSnackbar(MockupDataModel.success(ADD_CONTENT_SUCCESS_ALERT_TEXT), SnackBarUtil.CLASSES.success)
    }
  }

  deleteCoverImage(): void {
    this.tempCoverImage = null;
  }

  isDefaultImage(): boolean {
    return !this.tempProfileImage;
  }

  onCardImageChange(event: any, inputEl: HTMLInputElement): void {
    if (event.target.files.length === 0) return;
    const dialogConfig = this.getDialogConfig({imageChangedEvent: event})
    const dialogRef = this.dialog.open(ProfileImageCropperDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const fileName = this.getFileName(event.target.files[0]);
        this.tempProfileImage = new File([result], fileName, {type: result.type});
      }
      inputEl.value = '';
    });
  }

  onCardCoverImageChange(event: any, inputEl: HTMLInputElement): void {
    if (event.target.files.length === 0) return;
    const dialogConfig = this.getDialogConfig({imageChangedEvent: event})
    const dialogRef = this.dialog.open(CoverImageCropperDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const fileName = this.getFileName(event.target.files[0]);
        this.tempCoverImage = new File([result], fileName, {type: result.type});
      }
      inputEl.value = '';
    });
  }

  onCompanyLogoChange(event: any, inputEl: HTMLInputElement): void {
    if (event.target.files.length === 0) return;
    const dialogConfig = this.getDialogConfig({imageChangedEvent: event})
    const dialogRef = this.dialog.open(ProfileImageCropperDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const fileName = this.getFileName(event.target.files[0]);
        this.tempCompanyLogo = new File([result], fileName, {type: result.type});
      }
      inputEl.value = '';
    });
  }

  getFileName(file: File): string {
    return file.name;
  }

  get createCardControl(): any {
    return this.form.controls;
  }

  updateActiveState(userCardContent: UserCardContentRequest) {
    this.userCardContentRequest.filter(item => item.active).length;
    if (userCardContent.id) {
      userCardContent.action = Action.UPDATED
    }
    userCardContent.active = !userCardContent.active
    userCardContent.singleLink = false
  }

  deleteUserCardContent(userCardContent: UserCardContentRequest) {
    this.dialogRefDeleteContent = this.dialog.open(DeleteProfileCardComponent, {
      data: {
        deleteTitle: DELETE_CONTENT_TITLE,
        deleteDescription: DELETE_DESCRIPTION,
      }
    });
    this.dialogRefDeleteContent.afterClosed().subscribe((result: MatDialogRef<DeleteProfileCardComponent>) => {
      if (result) {
        const number = this.userCardContentRequest.indexOf(userCardContent);
        if (number !== -1) {
          this.userCardContentRequest.splice(number, 1);
        }
      }
    });
  }

  getImageAsSource(file: File | null): string {
    return file ? URL.createObjectURL(file) : 'assets/svg/defaultUserIcon.svg';
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.userCardContentRequest, event.previousIndex, event.currentIndex);
  }

  isAboutPage(): boolean {
    return this.selectedTab == 'About';
  }

  private showSnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }

  private handleErrorResponse(error: any) {
    if (error.status === 404) {
      this.showSnackBar('ContentWithDocId not found․', 'error');
    } else if (error.status === 500) {
      this.showSnackBar('Internal server error․', 'error');
    } else {
      this.showSnackBar('An unexpected error occurred․', 'error');
    }
  }

  private getDialogConfig(data: any): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxWidth = '700px';
    dialogConfig.width = 'auto';
    return dialogConfig;
  }

  search(term?: string) {
    this.hashtagService.getHashtags().subscribe(res => {
      this.matchingLineHashtags = res
    })
    if (term && term.trim().length > 0) {
      this.currentPageIndexForSearch = 0;
      this.currentQueryForSearch = term;
      this.hashtagService.search(term, this.currentPageIndexForSearch, this.pageSize)
        .subscribe({
          next: (hashtags: Hashtag[]) => {
            this.showSeeMoreButton = hashtags.length === this.pageSize;
            this.notFoundText = 'No result found';
            this.matchingLineHashtags = hashtags;
          }
        });
    } else {
      this.notFoundText = 'Search';
      this.showSeeMoreButton = false;
    }
  }

  loadMore(): void {
    this.hashtagService.search(this.currentQueryForSearch, ++this.currentPageIndexForSearch, this.pageSize)
      .subscribe({
        next: (hashtags: Hashtag[]) => {
          this.matchingLineHashtags = this.matchingLineHashtags.concat(hashtags);
          this.showSeeMoreButton = hashtags.length === this.pageSize;
          const element = this.ngSelectElement.nativeElement.querySelector('.scroll-host');
          if (element) {
            element.scrollBy({top: this.scrollStep, behavior: 'smooth'});
          }
        }
      });
  }

  fetchDefaultValues() {
    this.hashtagService.search('', this.currentPageIndexForSearch, this.pageSize)
      .subscribe({
        next: (hashtags: Hashtag[]) => {
          if (hashtags.length === this.pageSize) {
            this.showSeeMoreButton = true;
          }
          this.notFoundText = 'No result found';
          this.matchingLineHashtags = hashtags;
        }
      });
  }

  clearMultipleSearchResult(): void {
    if (this.form.get('hashtagList').value.length === 3) {
      this.notFoundText = '';
    } else {
      this.notFoundText = 'Search';
    }
    this.matchingLineHashtags = [];
    this.currentQueryForSearch = '';
    this.showSeeMoreButton = false;
  }

  isSingleLinkToggleActive() {
    const accessedSingleLinkContents = this.userCardContentRequest.filter(content => content.type != ContentType.DOCUMENT);
    return this.isAboutPage() || accessedSingleLinkContents.length === 0 || !this.isActiveContentsPresentAndNotDocument();
  }

  isContentHighlightToggleActive() {
    return (this.isAboutPage() || this.isSingleLink) || this.userCardContentRequest.length === 0 || !this.isActiveContentsPresentAndNotDocument();
  }

  isActiveContentsPresentAndNotDocument(): boolean {
    return !!this.userCardContentRequest.find(content => content.active && content.type != ContentType.DOCUMENT);
  }

  isControlTouchedAndInvalid(formControlName: string) {
    return this.createCardControl[formControlName].invalid
      && this.createCardControl[formControlName].touched;
  }

  hasControlRequiredError(formControlName: string) {
    return this.createCardControl[formControlName].errors?.['required']
      || this.createCardControl[formControlName].errors?.['whitespace'];
  }

  hasControlLengthError(formControlName: string) {
    const hasLengthError = this.createCardControl[formControlName].errors?.['minlength'] || this.createCardControl[formControlName].errors?.['maxlength'];
    return hasLengthError && !this.hasControlRequiredError(formControlName);
  }

  onClickContinue() {
    this.selectedTab = 'Content'
  }

  makeContentLinkSingleByContentId(contentId: bigint, identifier: number) {
    this.resetSingleLink();
    if (identifier == null && contentId != null) {
      this.setSingleLinkById(contentId);
    } else {
      this.setSingleLinkByIdentifier(identifier);
    }
  }

  get tooltipText(): string {
    if (this.activeIndividualSubscriptionPlan) {
      const subscriptionInfo = this.activeIndividualSubscriptionPlan.subscriptionInfoResponse;
      const title = this.translateSubscriptionTitle(subscriptionInfo.title);
      const linkCount = subscriptionInfo?.linkCount != null ?
        subscriptionInfo.linkCount.toString() :
        this.translateService.instant('subscription_plan_content.unlimited');
      const paymentMethodCount = subscriptionInfo?.paymentMethodCount;

      let paymentMethodText = '';
      if (paymentMethodCount) {
        const paymentMethodKey = paymentMethodCount === 1 ? 'payment_method' : 'payment_methods';
        paymentMethodText = `, ${paymentMethodCount} ${this.translateService.instant(`subscription_plan_content.${paymentMethodKey}`)}`;
      }

      const format = this.translateService.instant('subscription_plan_content.subscription_info_format');
      return format
        .replace('{title}', title)
        .replace('{linkCount}', linkCount)
        .replace('{paymentMethodText}', paymentMethodText);
    }
    return '';
  }

  private translateSubscriptionTitle(title: string): string {
    const titleMap: { [key: string]: string } = {
      'Starter': 'subscription_plans.starter',
      'Standard': 'subscription_plans.standard',
      'Premium': 'subscription_plans.premium',
      'Basic': 'subscription_plans.basic',
      'Professional': 'subscription_plans.professional',
      'Unlim': 'subscription_plans.unlim',
      'Free': 'subscription_plans.free'
    };

    const translationKey = titleMap[title];
    return translationKey ? this.translateService.instant(translationKey) : title;
  }

  getIdealDimensionsTooltip(dimensions: string): string {
    const format = this.translateService.instant('user_card.ideal_dimensions');
    return format.replace('{dimensions}', dimensions);
  }

  private resetSingleLink() {
    const contentWithSingleLink = this.userCardContentRequest.find(content => content.singleLink);
    if (contentWithSingleLink) {
      contentWithSingleLink.singleLink = false;
    }
  }

  private setSingleLinkById(contentId: bigint) {
    const contentById = this.userCardContentRequest.find(content => content.id === contentId);
    if (contentById) {
      contentById.singleLink = true;
    }
  }

  private setSingleLinkByIdentifier(identifier: number) {
    const contentByIdentifier = this.userCardContentRequest.find(content => content.identifier === identifier);
    if (contentByIdentifier) {
      contentByIdentifier.singleLink = true;
    }
  }

  private mapHashtagList() {
    const hashtagList: Array<Hashtag> = <Array<Hashtag>>this.form.value.hashtagList;
    if (!hashtagList || hashtagList.length == 0) {
      return [];
    }

    let stringList: string[] = [];

    hashtagList.forEach(tag => {
      stringList.push(tag.name);
    })

    return stringList;
  }

  private getUserCardContentWithoutFiles() {
    const contents = this.userCardContentRequest;
    contents.forEach(content => {
      if (content.placeholder?.name) {
        content.placeholder = content.placeholder.name;
      }
    })
    return contents;
  }

  private loadIndividualSubscription(): void {
    this.subscriptionService.getActiveIndividualSubscription().subscribe({
      next: (activeIndividualSubscriptionPlan) => {
        this.activeIndividualSubscriptionPlan = activeIndividualSubscriptionPlan;
      }
    });
  }

  protected readonly maxLengthConstant = maxLengthConstant;
  protected readonly ToggleSelectElModel = ToggleSelectElModel;
  protected readonly ToggleElModel = ToggleElModel;
  protected readonly SharedConstants = SharedConstants;
}
